const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 !bg-[#1c1c1cc4] flex items-center justify-center z-50">
      <div className="text-center">
        {/* Logo or Brand */}
        <div className="mb-8">
          <div className="w-24 h-24 mx-auto mb-4 relative">
            <div className="absolute inset-0 rounded-full border-4 border-white/60 animate-pulse"></div>
            <div className="absolute inset-2 rounded-full border-2 border-white/80 animate-ping"></div>
            <div className="absolute inset-4 rounded-full bg-white flex items-center justify-center">
              {/* Cloudinary logo image */}
              <img
                src={
                  `https://res.cloudinary.com/${import.meta.env.VITE_CLOUDINARY_NAME}/image/upload/f_auto,q_auto:best,w_180,h_180,c_fit/v1/logoext_mev1sf`
                }
                alt="GCO"
                className="w-15 h-15 object-contain"
              />
            </div>
          </div>
        </div>

        {/* Loading Animation */}
        <div className="mb-6">
          <div className="flex justify-center items-center space-x-2">
            <div className="w-3 h-3 bg-white/60 rounded-full animate-bounce"></div>
            <div className="w-3 h-3 bg-white/80 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
            <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          </div>
        </div>

       
      </div>

      {/* Background Animation */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-1/2 -left-1/2 w-full h-full opacity-20 animate-spin"></div>
        <div className="absolute -bottom-1/2 -right-1/2 w-full h-full opacity-10 animate-spin"></div>
      </div>
    </div>
  );
};

export default LoadingScreen;
